"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeItemFromArr = exports.filterObjectKeys = exports.mergeArryUnique = void 0;
function mergeArryUnique(arrOne, arrTwo) {
    let obj = {};
    if (Array.isArray(arrOne)) {
        arrOne.forEach((elem) => {
            obj[elem] = null;
        });
    }
    if (Array.isArray(arrTwo)) {
        arrTwo.forEach((elem) => {
            obj[elem] = null;
        });
    }
    return Object.keys(obj);
}
exports.mergeArryUnique = mergeArryUnique;
function filterObjectKeys(obj, keyArr) {
    let newObj = Object.assign({}, obj);
    if (Array.isArray(keyArr) && keyArr.length > 0) {
        keyArr.forEach((key) => {
            if (newObj[key]) {
                delete newObj[key];
            }
        });
    }
    return newObj;
}
exports.filterObjectKeys = filterObjectKeys;
function removeItemFromArr(arr, value) {
    var index = arr.indexOf(value);
    if (index > -1) {
        arr.splice(index, 1);
    }
    return arr;
}
exports.removeItemFromArr = removeItemFromArr;
//# sourceMappingURL=common.js.map